// Geneva expects <= 2 to be of 'error' classification
export var LoggingLevel;
(function (LoggingLevel) {
    LoggingLevel[LoggingLevel["error"] = 0] = "error";
    LoggingLevel[LoggingLevel["warn"] = 1] = "warn";
    LoggingLevel[LoggingLevel["info"] = 3] = "info";
    LoggingLevel[LoggingLevel["metric"] = 4] = "metric";
    LoggingLevel[LoggingLevel["verbose"] = 5] = "verbose";
    LoggingLevel[LoggingLevel["debug"] = 6] = "debug";
})(LoggingLevel || (LoggingLevel = {}));
//# sourceMappingURL=ilogger.js.map